define('../src/sublayouts/m10-footer/m10-footer',['jquery'], function ($) {

    'use strict';

    var M10_FOOTER = function ($component) {

        this.$component = $component;

        return this;
    };

    M10_FOOTER.prototype.init = function () {

            function footerFix(){
                var windowHeight = $(window).height(),
                    areaHeight = $('body').find('.rs_area').height();

                if(windowHeight > areaHeight){
                    $('footer').addClass('fixed-footer')
                }
                if(windowHeight <= areaHeight){
                    $('footer').removeClass('fixed-footer')    
                }
            };

            footerFix();
            $('footer').css('opacity', '1');

            $( window ).on( "orientationchange resize", function( event ) {
                footerFix()
            })
    }


    return M10_FOOTER;

});
